module.exports = __webpack_public_path__ + "img/glogo226.aa6e708f.png";